import AreaTemplate from '../AreaTemplate';

const schema = {
  '@context': 'https://schema.org',
  '@type': 'ElectricalContractor',
  name: 'Electrician Solutions Fresno — Hanford',
  description: 'Licensed electrician serving Hanford, CA. C-10 certified electrical contractor for residential and commercial electrical work in Hanford and Kings County.',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Hanford',
    addressRegion: 'CA',
    postalCode: '93230',
    addressCountry: 'US',
  },
  geo: { '@type': 'GeoCoordinates', latitude: '36.3274', longitude: '-119.6457' },
  url: 'https://electriciansolutionsfresno.com/areas/hanford',
  telephone: '+1-559-123-4567',
  priceRange: '$$',
  areaServed: { '@type': 'City', name: 'Hanford', '@id': 'https://en.wikipedia.org/wiki/Hanford,_California' },
};

const faqs = [
  {
    q: 'Do you service Hanford, CA for electrical work?',
    a: 'Yes! Electrician Solutions Fresno serves all of Hanford, CA and Kings County with licensed C-10 electrical contractor services. We cover residential rewiring, commercial electrical installations, panel upgrades, EV chargers, and 24/7 emergency electrical repairs throughout Hanford.',
  },
  {
    q: 'How long does it take to get an electrician in Hanford?',
    a: 'We typically dispatch a licensed electrician to Hanford within 90 minutes for emergencies. For scheduled residential or commercial work, we offer convenient booking with same-week or next-day appointments available for most Hanford projects.',
  },
  {
    q: 'Can you upgrade my electrical panel in Hanford?',
    a: 'Absolutely. We upgrade electrical panels in Hanford from 100A to 200A or 400A service. All work is permitted through the City of Hanford Building Department and inspected to California electrical code standards.',
  },
  {
    q: 'Do you install EV chargers in Hanford?',
    a: 'Yes. We install Level 2 EV charging stations at Hanford homes and businesses. As EV adoption grows in Kings County, we help Hanford residents charge at home overnight with convenient, code-compliant Level 2 charger installations.',
  },
  {
    q: 'What Hanford areas do you cover?',
    a: 'We serve all of Hanford including downtown Hanford, the Civic Auditorium district, northeast Hanford residential areas, the 11th Avenue commercial corridor, Lemoore area, and rural Kings County agricultural properties.',
  },
  {
    q: 'Are you licensed for commercial electrical work in Hanford?',
    a: 'Yes. Our C-10 license covers all commercial electrical work in Hanford including retail stores, restaurants, medical offices, warehouses, and the Kings County commercial corridor. We also serve Hanford\'s growing industrial sector.',
  },
];

const HanfordPage = () => (
  <AreaTemplate
    area="Hanford"
    areaSlug="hanford"
    state="CA"
    county="Kings County"
    population="60,000+"
    description="Electrician Solutions Fresno delivers premium C-10 licensed electrical services throughout Hanford, CA and Kings County. From the charming historic downtown district to modern residential developments and Kings County agricultural facilities, our certified Hanford electricians provide safe, reliable, and code-compliant electrical solutions for every type of project."
    neighborhoods={['Downtown Hanford', 'Northeast Hanford', 'West Hanford', '11th Ave Corridor', 'Lemoore Area', 'Kings County Rural', 'Civic Center District', 'Airport Area']}
    nearbyAreas={[
      { name: 'Visalia', slug: 'visalia' },
      { name: 'Tulare', slug: 'tulare' },
      { name: 'Fresno', slug: 'fresno' },
      { name: 'Selma', slug: 'selma' },
      { name: 'Sanger', slug: 'sanger' },
    ]}
    faqs={faqs}
    heroImage="https://public.readdy.ai/ai/img_res/74249113f7c77c19ab90abf7b4ec3e00.jpg"
    heroImageAlt="Licensed Electrician in Hanford CA"
    teamImage="https://readdy.ai/api/search-image?query=Professional%20electrician%20team%20in%20uniforms%20posing%20in%20front%20of%20Hanford%20California%20downtown%20historic%20district%20beautiful%20architecture%20water%20tower%20Kings%20County%20California%20sunny%20sky%20agricultural%20Central%20Valley%20backdrop&width=800&height=600&seq=hanford_team_001&orientation=landscape"
    teamImageAlt="Electrician Solutions team serving Hanford CA"
    schema={schema}
  />
);

export default HanfordPage;
